// Houdt een geopende app gelijk met de versie op de server.
//
// De service worker levert bij het openen de laatst gecachte bundel; een
// nieuwe versie zou anders pas na een tweede herlaad actief worden, en een
// tabblad dat open blijft staan zou nooit verversen. Daarom vergelijkt de app
// zijn eigen build-id met /version.json en herlaadt zichzelf bij een verschil.
// Invoer staat in localStorage en gaat daarbij niet verloren; tijdens een
// upload wordt de herlaad uitgesteld.

const CURRENT = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : null;
const CHECK_INTERVAL_MS = 2 * 60 * 1000;
const RELOAD_GUARD = 'zbs:herladen-voor-build';

let busy = 0;
let pending = false;

export function setBusy(delta) {
    busy = Math.max(0, busy + delta);
    if (busy === 0 && pending) { check(); }
}

async function activateNewServiceWorker() {
    if (!('serviceWorker' in navigator)) { return; }
    const regs = await navigator.serviceWorker.getRegistrations();
    if (regs.length === 0) { return; }
    const switched = new Promise((resolve) => {
        navigator.serviceWorker.addEventListener('controllerchange', resolve, { once: true });
        setTimeout(resolve, 8000);
    });
    await Promise.all(regs.map(r => r.update().catch(() => {})));
    const waiting = regs.some(r => r.installing || r.waiting);
    if (waiting) { await switched; }
}

async function check() {
    if (!CURRENT || import.meta.env.DEV) { return; }
    try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) { return; }
        const { build } = await res.json();
        if (!build || build === CURRENT) { pending = false; return; }
        if (busy > 0) { pending = true; return; }
        // Eén poging per nieuwe build, zodat een mislukte update geen herlaadlus geeft.
        if (window.sessionStorage.getItem(RELOAD_GUARD) === build) { return; }
        window.sessionStorage.setItem(RELOAD_GUARD, build);
        await activateNewServiceWorker();
        window.location.reload();
    } catch {
        // Offline of geen JSON: later opnieuw.
    }
}

export function startVersionCheck() {
    if (typeof window === 'undefined') { return; }
    check();
    setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') { check(); }
    });
    window.addEventListener('online', check);
}
